<template>
  <div>
    <ActiveBacklogColumn
      v-if="!details"
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailView="switchView"
    ></ActiveBacklogColumn>
    <ActiveBacklogStacked
      v-else
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailView="switchView"
    ></ActiveBacklogStacked>
  </div>
</template>

<script>
import ActiveBacklogColumn from "../../../components/dashboard/active-backlog/ActiveBacklogColumn.vue";
import ActiveBacklogStacked from "../../../components/dashboard/active-backlog/ActiveBacklogStacked";

export default {
  name: "ActiveBacklog",
  components: {
    ActiveBacklogColumn,
    ActiveBacklogStacked
  },
  data: function() {
    return {
      details: false
    };
  },
  methods: {
    switchView() {
      this.details = !this.details;
    }
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
